window.dbs = window.dbs || {}
dbs.google = dbs.google || {}

dbs.google.placesAutocompleteService = function (google) {
  const self = this

  // See: https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service
  const AutocompleteService = new google.maps.places.AutocompleteService()

  /**
   * Retrieves place autocomplete predictions based on the supplied autocomplete request.
   * See: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesService.getDetails
   * @function
   * @param {object} request - request:  AutocompletionRequest. See: https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest
   * @param {function} callback - callback:  function(Array<AutocompletePrediction> optional, PlacesServiceStatus): void optional A callback accepting an array of AutocompletePrediction objects and a PlacesServiceStatus value as argument.
   */
  self.getPlacePredictions = function (request, callback) {
    AutocompleteService.getPlacePredictions(request, function (predictions, status) {
      callback(predictions, status)
    })
  }
}
